export const FETCH_DASHBOARD_REQUEST = 'FETCH_DASHBOARD_REQUEST'
export const FETCH_DASHBOARD_SUCCESS = 'FETCH_DASHBOARD_SUCCESS'
export const FETCH_DASHBOARD_FAILURE = 'FETCH_DASHBOARD_FAILURE'

export const UPDATE_DASHBOARD_FILTERS = 'UPDATE_DASHBOARD_FILTERS'
